import { BookingsList, MyCalender, VendorProfile } from "../../lazyComponent";
import { BusinessRoutes } from "../routes";
const teamMemberRouting = [
    { path: `${BusinessRoutes.profile}`, Component: VendorProfile },
    { path: `${BusinessRoutes.bussinessbookings}`, Component: BookingsList },
    { path: `${BusinessRoutes.calender}`, Component: MyCalender },
];
export default teamMemberRouting;